import create from "zustand";

const useStore = create((set) => ({
  toggle: () => set(() => ({ open: true })),
  setConsumerID: (consumerID) => set(() => ({ consumerID, open: true })),
  clear: () => set(() => ({ consumerID: null, open: false })),
}));

export default useStore;
